var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { JsonObject, JsonProperty } from "json2typescript";
import { CategoryModel } from "@core/models/positions/category.model";
let PositionModel = class PositionModel {
    constructor() {
        this.code = '';
        this.name = '';
        this.id = -1;
        this.color = '';
        this.category = new CategoryModel();
    }
};
__decorate([
    JsonProperty("code", String)
], PositionModel.prototype, "code", void 0);
__decorate([
    JsonProperty("name", String)
], PositionModel.prototype, "name", void 0);
__decorate([
    JsonProperty("id", Number)
], PositionModel.prototype, "id", void 0);
__decorate([
    JsonProperty("color", String, true)
], PositionModel.prototype, "color", void 0);
__decorate([
    JsonProperty("category", CategoryModel, true)
], PositionModel.prototype, "category", void 0);
PositionModel = __decorate([
    JsonObject("PositionModel")
], PositionModel);
export { PositionModel };
let BasicPositionModel = class BasicPositionModel {
    constructor() {
        this.code = '';
    }
};
__decorate([
    JsonProperty("code", String)
], BasicPositionModel.prototype, "code", void 0);
BasicPositionModel = __decorate([
    JsonObject("BasicPositionModel")
], BasicPositionModel);
export { BasicPositionModel };
let BrandPositionModel = class BrandPositionModel {
    constructor() {
        this.code = '';
        this.name = '';
        this.id = -1;
        this.is_primary = false;
        this.category = new CategoryModel();
    }
};
__decorate([
    JsonProperty("code", String)
], BrandPositionModel.prototype, "code", void 0);
__decorate([
    JsonProperty("name", String)
], BrandPositionModel.prototype, "name", void 0);
__decorate([
    JsonProperty("id", Number)
], BrandPositionModel.prototype, "id", void 0);
__decorate([
    JsonProperty("is_primary", Boolean, true)
], BrandPositionModel.prototype, "is_primary", void 0);
__decorate([
    JsonProperty("category", CategoryModel, true)
], BrandPositionModel.prototype, "category", void 0);
BrandPositionModel = __decorate([
    JsonObject("BrandPositionModel")
], BrandPositionModel);
export { BrandPositionModel };
//# sourceMappingURL=position.model.js.map